<template>
    <svg aria-hidden="true" focusable="false" class="site-tour" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path d="M6.58691 9.61694L8.935 9.61694" stroke="black" stroke-width="0.75" stroke-linecap="round" />
        <path d="M6 11.965L8.93511 11.965" stroke="black" stroke-width="0.75" stroke-linecap="round" />
        <path d="M6.58691 14.3131L9.52202 14.3131" stroke="black" stroke-width="0.75" stroke-linecap="round" />
        <path
            d="M14.2203 16.0741C13.654 16.0741 11.5175 13.6771 10.9269 12.621C10.6108 12.0616 10.4475 11.4224 10.4475 10.7763C10.4475 8.69532 12.1394 7 14.2238 7C16.3047 7 18 8.69185 18 10.7763C18 11.4398 17.8263 12.0929 17.4963 12.6627C16.9474 13.6041 14.797 16.0741 14.2203 16.0741Z"
            stroke="black"
            stroke-width="0.75"
            stroke-miterlimit="10" />
        <path
            d="M14.2202 12.3711C13.3434 12.3711 12.6289 11.6566 12.6289 10.7798C12.6289 9.90298 13.3434 9.18848 14.2202 9.18848C15.097 9.18848 15.8115 9.90299 15.8115 10.7798C15.8115 11.6566 15.097 12.3711 14.2202 12.3711Z"
            stroke="black"
            stroke-width="0.75"
            stroke-miterlimit="10" />
    </svg>
</template>
